<template>
    <!-- 对话框 -->
    <el-dialog title="减免配置" :visible.sync="show" :before-close="closeDialog" width="50%" append-to-body>
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="180px">
                    <el-form-item label="开关">
                        <el-switch v-model="submit_data.status" active-value="1" inactive-value="0"> </el-switch>
                    </el-form-item>
                    <el-form-item label="司机加速包金额:">
                        <el-input
                            v-model="submit_data.delay_fee"
                            :placeholder="submit_rules.delay_fee.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="免减时长（分钟）:">
                        <el-input
                            v-model="submit_data.reduction_duration"
                            :placeholder="submit_rules.reduction_duration.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                        <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            content="活动开启后，规定时间内司机到达，订单金额不减免"
                        >
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover>
                    </el-form-item>

                    <el-form-item label="每超（分钟）:">
                        <el-input
                            v-model="submit_data.exceed_minute"
                            :placeholder="submit_rules.exceed_minute.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="减免:">
                        <el-input
                            v-model="submit_data.exceed_fee"
                            :placeholder="submit_rules.exceed_fee.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>

                    <el-form-item label="减免封顶:">
                        <el-input
                            v-model="submit_data.fee_top"
                            :placeholder="submit_rules.fee_top.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                        <el-popover placement="top-start" width="200" trigger="hover" content="封顶金额为最大减免金额">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="第三方:">
                        <el-checkbox-group v-model="third_auth">
                            <el-checkbox v-for="item in partnerList" :label="item.order_source" :key="item.order_source">{{
                                item.name
                            }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-form-item label="公司承担百分比:">
                        <el-input
                            @input="getRate('company')"
                            v-model="submit_data.company_bear_rate"
                            :placeholder="submit_rules.company_bear_rate.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                        <el-popover placement="top-start" width="200" trigger="hover" content="减免金额由公司承担百分比">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover>
                    </el-form-item>

                    <el-form-item label="司机承担百分比:">
                        <el-input
                            @input="getRate('driver')"
                            v-model="submit_data.driver_bear_rate"
                            :placeholder="submit_rules.driver_bear_rate.placeholder"
                            style="width: 170px; margin-right: 5px"
                        >
                        </el-input>
                        <el-popover placement="top-start" width="200" trigger="hover" content="减免金额由司机承担百分比">
                            <i class="el-icon-question" slot="reference"></i>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="注意:">
                        <div style="color: red">司机承担百分比和公司承担百分比的和应为100%</div>
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        @toJSON="toJSON"
                        :data="submit_data"
                        :rules="submit_rules"
                        url="/delayreduction/addDelayReductionConf"
                        :JSON_Boolean="true"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
var _this;
import bus from '@/components/common/bus';
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config.js'; //配置
export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.getDelayReductionConf();
            _this.getPartnerList();
        }
    },

    data() {
        return {
            third_auth: [],
            show: false,
            partnerList: [],

            // 表单数据
            submit_data: {
                status: '',
                delay_fee: '',

                reduction_duration: '',
                exceed_minute: '',
                exceed_fee: '',
                fee_top: '',
                company_bear_rate: '',
                driver_bear_rate: '',
                third_auth: ''
            },
            search_data: {
                page: 1,
                limit: 10,
                billno: '',
                status: '',
                pay_channel: '',
                order_fixed_array: '',
                platform: '',
                complete_fixed_array: '',
                consumer_name: '',
                consumer_phone: '',
                start_name: '',
                driver_phone: '',
                driver_name: '',
                admin_name: '',
                admin_phone: '',
                order_mode_code: '',
                is_new_visit: '',
                visit_status: '',
                consumer_vip: '',
                port: '',
                order_code: '',
                group_wallet_code: '',
                order_source: '',
                coupon_mode_code: '',
                order_consumer_cancel_status: '',
                pay_no: '',
                cancel_status: '',
                order_type: ''
            },

            submit_rules: {
                delay_fee: {
                    placeholder: '司机加速包金额',
                    rules: {
                        required: true,
                        message: '司机加速包金额为大于等于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                reduction_duration: {
                    placeholder: '减免时长',
                    rules: {
                        required: true,
                        message: '减免时长为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                exceed_minute: {
                    placeholder: '每超',
                    rules: {
                        required: true,
                        message: '每超为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                exceed_fee: {
                    placeholder: '减免',
                    rules: {
                        required: true,
                        message: '减免为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                fee_top: {
                    placeholder: '减免封顶',
                    rules: {
                        required: true,
                        message: '减免封顶为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                company_bear_rate: {
                    placeholder: '公司承担百分比',
                    rules: {
                        required: false,
                        message: '公司承担百分比为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                driver_bear_rate: {
                    placeholder: '司机承担百分比',
                    rules: {
                        required: true,
                        message: '司机承担百分比为大于等于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        getRate(val) {
            if (val == 'company') {
                _this.submit_data.driver_bear_rate = 100 - Number(_this.submit_data.company_bear_rate);
            }
            if (val == 'driver') {
                _this.submit_data.company_bear_rate = 100 - Number(_this.submit_data.driver_bear_rate);
            }
        },
        toJSON() {
            _this.submit_data.third_auth = JSON.stringify(_this.third_auth);

            if (Number(_this.submit_data.company_bear_rate) + Number(_this.submit_data.driver_bear_rate) !== 100) {
                this.$message.error('司机承担百分比和公司承担百分比的和应为100%！');
                bus.$emit('isOnsubmit', false);
                bus.$emit('btnStatus', false);
            } else {
                bus.$emit('isOnsubmit', true);
                bus.$emit('btnStatus', true);
            }
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {
                status: '',
                reduction_duration: '',
                delay_fee: '',
                exceed_minute: '',
                exceed_fee: '',
                fee_top: '',
                company_bear_rate: '',
                driver_bear_rate: '',
                third_auth: ''
            };
            _this.third_auth = [];
        },

        getDelayReductionConf() {
            _this
                .$post('/delayreduction/getDelayReductionConf', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.submit_data.status = res.data.status.val;
                    _this.submit_data.delay_fee = res.data.delay_fee;
                    _this.submit_data.company_bear_rate = res.data.company_bear_rate;
                    _this.submit_data.driver_bear_rate = res.data.driver_bear_rate;
                    _this.submit_data.fee_top = res.data.fee_top;
                    _this.submit_data.protocol = res.data.protocol;
                    if (res.data.third_auth == null || res.data.third_auth == '') {
                        _this.third_auth = [];
                    } else {
                        _this.third_auth = res.data.third_auth;
                        _this.submit_data.third_auth = res.data.third_auth;
                    }

                    _this.submit_data.type = res.data.type || '0';
                    _this.submit_data.reduction_duration = res.data.reduction_duration || '';
                    _this.submit_data.exceed_minute = res.data.exceed_minute || '';
                    _this.submit_data.exceed_fee = res.data.exceed_fee || '';

                    _this.submit_data.go_way_time_greater = res.data.go_way_time_greater || '';
                    _this.submit_data.go_way_time_greater_amount = res.data.go_way_time_greater_amount || '';
                    _this.submit_data.go_way_time_less = res.data.go_way_time_less || '';
                    _this.submit_data.go_way_time_less_amount = res.data.go_way_time_less_amount || '';
                    _this.submit_data.order_amount_less = res.data.order_amount_less || '';
                    _this.submit_data.order_amount_less_compute = res.data.order_amount_less_compute || '';
                    _this.submit_data.order_amount_greater = res.data.order_amount_greater || '';
                    _this.submit_data.order_amount_greater_compute = res.data.order_amount_greater_compute || '';
                })
                .catch((err) => {});
        },
        getPartnerList() {
            // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
            _this
                .$post('/order/getPartnerList', _this.search_data, '', 'normal')
                .then((res) => {
                    _this.partnerList = res.data;

                    // axios.defaults.baseURL = config.axios_baseURL; //请求normal url
                })
                .catch((err) => {});
            // axios.defaults.baseURL = config.axios_baseURL; //请求normal url
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.el-icon-question:hover + span {
    display: block;
}
.el-icon-question + span {
    display: none;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
